<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    editTitle="Reemitir NF-e"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    editSaveButtonLabel="Reemitir NF-e"
    editIcon="mdi-file-restore"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        @formLoading="pageLoading=true"
        @formStopLoading="pageLoading=false"
        :printing="printing"
        id="printableELement"
        @formErrors="errorsFromForm"
        formType="edit"
        :modelNameSingular="modelNameSingular"
      />
      <!-- :formErrors="formErrors" -->
    </template>

    <template slot="action1">
      <BasePrint
        printableElementId="printableELement"
        printButtonLabel="Imprimir Prévia da NF-e"
        printTitle="Prévia das Informações da NF-e"
        @start-printing="printing = pageLoading = true"
        @stop-printing="printing = pageLoading = false"
        :disabledPrint="editableEntry && editableEntry.taxPayerId ? false : true"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";
import BasePrint from "@shared_components/base_print.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      printing: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit,
    BasePrint: BasePrint,
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_OUTBOUND_NFCE_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.nfce;
          this.extraData = response.data;
          // console.log("NFCe", this.editableEntry);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(nfce) {
      // console.log("Edit NFCE ", nfce, nfce.validations, this.deepFilterEntryWithAllowedFieldsForMutation(nfce, nfce.validations))
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_NFCE_MUTATION,
          variables: {
            id: nfce.id,
            input: this.deepFilterEntryWithAllowedFieldsForMutation(nfce, nfce.validations)
          }
        })
        .then(response => {
          console.log(response.data);
          var errors = response.data.reIssueSaleNfpe.errors
          if (errors.length){
            this.formErrors = errors;
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
            this.pageLoading = false;
            if (this.$router.currentRoute.name != "OutboundNfce") {
              this.$router.push({ name: "OutboundNfce"});
            }
            this.resetForm();
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    },
    errorsFromForm: function(errors) {
      this.formErrors = this.formErrors.concat(errors);
    }
  }
};

const LOAD_OUTBOUND_NFCE_QUERY = gql `
  query ($id: ID!) {
    accountContext {
      nfce(id: $id) {
        id
        series
        number
        groundId
        cfopId
        issueDate
        issueTime
        deliveredReceivedDate
        deliveredReceivedTime
        mailingList
        status
        cashFlowId
        cashFlowIdsAttribute
        cashFlows {
          id
        }
        taxPayerId
        nfeOperationLocationId
        observations
        cashFlowObservations
        validations
        allAvailableCfops {
          id
          code
          description
          text
        }
        nfeItems{
          id
          description
          number
          orderCode
          item {
            name
            barcode
            unit {
              name
            }
          }
          itemId
          taxationRuleId
          taxationRule {
            id
            operationDestinationTypeName
            taxRegimeTypeName
            icmsOrigin {
              text
            }
            icmsCst {
              text
            }
            icmsPredBc
            icmsPredBcText
            icmsPredBcSt
            icmsPredBcStText
            icmsPicms
            icmsPicmsText
            icmsPicmsSt
            icmsPicmsStText
            icmsPredBc
            icmsPfcp
            icmsPfcpText
            icmsPfcpSt
            icmsPfcpStText
            icmsPdif
            icmsPdifText
            icmsModBc {
              text
            }
            icmsModBcSt {
              text
            }
            pisValiqProd
            pisValiqProdText
            pisPpis
            pisPpisText
            pisCst {
              text
            }
            cofinsValiqProd
            cofinsValiqProdText
            cofinsPcofins
            cofinsPcofinsText
            cofinsCst {
              text
            }
            taxationGroup {
              ncm {
                text
                taxUnit
              }
            }
          }
          quantity
          quantityText
          unitPrice
          unitPriceText
          totalPrice
          totalPriceText
          totalPriceWithExtraValues
          totalPriceWithExtraValuesText
          cofinsVcofins
          discountValue
          icmsVbc
          icmsVbcText
          icmsVbcSt
          icmsVbcStText
          icmsVfcp
          icmsVfcpText
          icmsVfcpSt
          icmsVfcpStText
          icmsVfcpStRet
          icmsVst
          icmsVicmsSt
          icmsVicmsStText
          icmsVicms
          icmsVicmsText
          icmsVicmsDeson
          icmsVicmsOp
          icmsVicmsOpText
          icmsVicmsDif
          icmsVicmsDifText
          icmsVbcFcp
          icmsVbcFcpText
          icmsVbcFcpSt
          icmsVbcFcpStText
					pisVbc
          pisVbcText
          pisVpis
          pisVpisText
          cofinsVbc
          cofinsVbcText
          cofinsVcofins
          cofinsVcofinsText
          carriageValue
          carriageValueText
          insuranceValue
          insuranceValueText
          discountValue
          discountValueText
          otherExpensesValue
          otherExpensesValueText
        }
        cofinsVcofins
        cofinsVcofinsText
        icmsVbc
        icmsVbcText
        icmsVbcSt
        icmsVbcStText
        icmsVfcp
        icmsVfcpText
        icmsVfcpSt
        icmsVfcpStText
        icmsVfcpStRet
        icmsVfcpStRetText
        icmsVicms
        icmsVicmsText
        icmsVicmsDeson
        icmsVicmsDesonText
        icmsVst
        icmsVstText
        pisVpis
        pisVpisText
        status
        vDesc
        vDescText
        vFrete
        vFreteText
        vIi
        vIiText
        vIpi
        vIpiText
        vIpiDevol
        vIpiDevolText
        vSeg
        vSegText
        vOutro
        vOutroText
        vProd
        vProdText
        vTotTrib
        vTotTribText
        vNf
        vNfText
      }
      allTaxPayers {
        id
        text
      }
      allGrounds {
        id
        name
      }
    }
    globalContext {
      allNfeOperationLocations {
        id
        text
      }
    }
  }
`;

const UPDATE_NFCE_MUTATION = gql `
  mutation($id: ID!, $input: ReIssueSaleNfpeInputObject!) {
    reIssueSaleNfpe(id: $id, input: $input) {
      nfpe {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>

<!-- mutation {
  updatePerson(
    id: 10,
    input: {
      kind: 1,
    cnpj: "00000000000000",
      isCollaborator: false,
      isCustomer: false,
      isSupplier: true,
      isCarrier: true,
      name: "philips programmator2",
      tradingName: "Pessoa2",
      taxReceiptEmail: "philips_programmator@agrosim.com.br",
      addressesAttributes: [
        {
          postalCode: "93900000",
          cityId: 1100015,
          street: "Logradouro",
          neighborhood: "Bairro",
          number: "Nº",
          complement: "Complemento",
        }
      ]
  }) {
    person {
      id
    }
    errors
  }
} -->
